// A saguaro cactus: a tall ribbed green column with two upturned arms. Ported
// 1:1 from age-of-mcp's classic cactus-saguaro.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.13, 0.15, 1.2, 8),
      color: "#3f7a44", position: [0, 0.6, 0] },
    { geometry: new THREE.SphereGeometry(0.13, 8, 6),
      color: "#468a4c", position: [0, 1.2, 0] },              // rounded top
    // left arm: out then up
    { geometry: new THREE.CylinderGeometry(0.07, 0.08, 0.3, 7),
      color: "#3f7a44", position: [-0.22, 0.62, 0], rotation: [0, 0, 1.2] },
    { geometry: new THREE.CylinderGeometry(0.07, 0.08, 0.42, 7),
      color: "#468a4c", position: [-0.3, 0.86, 0] },
    // right arm, a bit higher
    { geometry: new THREE.CylinderGeometry(0.06, 0.07, 0.26, 7),
      color: "#3f7a44", position: [0.2, 0.82, 0.04], rotation: [0, 0, -1.2] },
    { geometry: new THREE.CylinderGeometry(0.06, 0.07, 0.36, 7),
      color: "#468a4c", position: [0.27, 1.04, 0.04] },
  ];
}

export const cactusSaguaro = defineModel({
  id: "cactus-saguaro",
  batchId: "standard",
  name: "Cactus saguaro",
  tags: ["scenery","cactus","saguaro","low-poly","age-of-mcp","classic"],
  summary: "Low-poly cactus saguaro.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.36,
  parts: () => partsFor(),
  animations: [],
});
